module.exports = __webpack_public_path__ + "static/img/ARAD4S_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD4S_1.png
// module id = fbQL
// module chunks = 0